const translations = {
  seo: {
    title: "Glas vervangen Eindhoven | Dubbel glas, HR++, enkel | Op offerte",
    description: "Gebroken ruit, enkel glas naar HR++ of isolatieglas in Eindhoven. Op maat, snelle service. 10 jaar garantie. Bel 040 798 7470.",
  },
  breadcrumb: {
    home: "Home",
    diensten: "Diensten",
    current: "Glas vervangen",
  },
  hero: {
    pill: "DIENST — GLAS EN BEGLAZING",
    h1: "Glas en beglazing vervangen in Eindhoven",
    subhead: "Gebroken ruit, enkel glas of upgrade naar HR++ isolatieglas? Wij meten, leveren en plaatsen alle soorten glas op maat — vakkundig met 10 jaar garantie.",
    usps: [
      "Op maat in 5-10 werkdagen",
      "Spoedservice gebroken ruit",
      "Advies HR++ subsidies",
    ],
    ctaPhone: "040 798 7470",
    ctaOfferte: "Gratis offerte",
  },
  spoedBanner: {
    text: "🚨 GEBROKEN RUIT? Vandaag nog noodbeveiliging, nieuw glas binnen 48 uur. Bel: 040 798 7470",
  },
  intro: {
    h2: "Glas vervangen: van noodgeval tot energiebesparing",
    p1: "Een ruit kan plotseling stuk gaan door een steen, een bal of een storm. Maar glas vervangen is ook een bewuste keuze voor verduurzaming: enkel glas vervangen door HR++ scheelt jaarlijks honderden euro's aan stookkosten.",
    p2: "Wij plaatsen alle soorten glas in bestaande kozijnen: enkel glas voor monumentale panden, HR++ isolatieglas voor energiezuinige woningen, HR+++ triple glas of veiligheidsglas voor specifieke wensen.",
    p3: "Voor spoedgevallen rijden wij vandaag nog uit voor noodbeveiliging. Het maatwerk-glas wordt gefabriceerd in 5-10 werkdagen, daarna vakkundig geplaatst met 10 jaar garantie.",
  },
  soortenGlas: {
    h2: "Welke soorten glas plaatsen wij?",
    rows: [
      {
        title: "Enkel glas",
        desc: "Voor monumentale panden of bijgebouwen. Snelle levering en plaatsing.",
      },
      {
        title: "Dubbel glas HR / HR+",
        desc: "Standaard isolatieglas voor basis-energiebesparing. Goede oplossing voor oudere woningen.",
      },
      {
        title: "HR++ isolatieglas",
        desc: "Meest gekozen upgrade. Bespaart 300-600 euro/jaar op stookkosten. Vraag naar subsidies.",
      },
      {
        title: "HR+++ triple glas",
        desc: "Maximale isolatie, nieuwbouw-niveau. Ideaal voor passiefhuizen.",
      },
      {
        title: "Veiligheidsglas",
        desc: "Gelaagd of gehard glas voor inbraakwering of kinderveiligheid.",
      },
      {
        title: "Glas-in-lood",
        desc: "Restauratie van historisch glas in karakteristieke panden.",
      },
    ],
  },
  hrBlock: {
    h2: "Energie besparen met HR++",
    p1: "Een woning met enkel glas verliest tot 40% van zijn warmte via de ramen. HR++ glas bespaart een gemiddeld huishouden 300-600 euro per jaar op stookkosten.",
    p2: "HR++ heeft een isolatiewaarde van U=1.1 W/m²K, tegenover U=5.8 voor enkel glas. U merkt het direct: minder tocht, minder condens en betere geluidsisolatie.",
    p3: "Vraag naar de actuele ISDE-subsidie en gemeentelijke regelingen in Eindhoven voor verduurzaming. Wij adviseren u gratis over de mogelijkheden en helpen bij de aanvraag. Meer weten over ISDE-subsidie 2026?",
  },
  werkwijze: {
    h2: "Glas vervangen in 4 stappen",
    steps: [
      { nr: "01", title: "Inmeting", desc: "Gratis ter plaatse" },
      { nr: "02", title: "Offerte", desc: "Heldere prijs en termijn" },
      { nr: "03", title: "Productie", desc: "Glas op maat in 5-10 werkdagen" },
      { nr: "04", title: "Plaatsing", desc: "Vakkundig + 10 jaar garantie" },
    ],
  },
  prijzen: {
    h2: "Wat kost glas vervangen?",
    note: "Incl. plaatsing, excl. 21% BTW.",
    rows: [
      { dienst: "Inmeting + offerte", prijs: "Gratis", tijd: "30 min" },
      { dienst: "Enkel glas", prijs: "Vanaf €145/m²", tijd: "1-2u" },
      { dienst: "Dubbel glas HR", prijs: "Vanaf €165/m²", tijd: "1-2u" },
      { dienst: "HR++ isolatieglas", prijs: "Vanaf €185/m²", tijd: "1-2u" },
      { dienst: "HR+++ triple glas", prijs: "Vanaf €245/m²", tijd: "2-3u" },
      { dienst: "Veiligheidsglas", prijs: "Op offerte", tijd: "1-3u" },
      { dienst: "Noodbeveiliging gebroken ruit", prijs: "€165", tijd: "1u" },
    ],
  },
  waarom: {
    h2: "Waarom wij?",
    reasons: [
      { nr: "01", title: "Glas op maat in 5-10 werkdagen", desc: "Snelle levertijd door efficiënte productie" },
      { nr: "02", title: "Spoedservice gebroken ruit", desc: "Vandaag nog noodbeveiliging" },
      { nr: "03", title: "Advies HR++ subsidies", desc: "Wees zeker van maximale subsidie" },
      { nr: "04", title: "10 jaar schriftelijke garantie", desc: "Op glas en plaatsing" },
    ],
  },
  faq: {
    h2: "Veelgestelde vragen",
    items: [
      { q: "Kan elk kozijn HR++ glas dragen?", a: "De meeste bestaande kozijnen kunnen HR++ glas dragen zonder aanpassing. Bij enkele specifieke profielen moet er een aanpassing worden gedaan aan het zetwerk. Onze monteurs beoordelen dit tijdens de gratis inmeting en geven eerlijk advies." },
      { q: "Hoe lang duurt het om glas te vervangen?", a: "De productietijd is 5-10 werkdagen voor maatwerk glas. De plaatsing zelf duurt gemiddeld 1 tot 2 uur per raam, afhankelijk van het formaat en type glas. Bij spoedgevallen regelen wij vandaag nog noodbeveiliging." },
      { q: "Is er subsidie voor HR++ glas?", a: "Ja, er zijn actuele ISDE-subsidies beschikbaar voor energiebesparende maatregelen, waaronder glas vervangen. Daarnaast kunnen gemeenten eigen regelingen hebben. Wij adviseren u graag over de actuele subsidiemogelijkheden in Eindhoven." },
      { q: "Spoedreparatie bij een gebroken ruit?", a: "Bel ons direct op 040 798 7470. Wij regelen vandaag nog noodbeveiliging: een veiligheidsplaat over de opening. Het maatwerk-glas wordt in productie genomen en binnen 5-10 werkdagen geplaatst." },
      { q: "Wat is het verschil tussen veiligheidsglas en standaard glas?", a: "Veiligheidsglas bestaat uit gelaagd of gehard glas. Gehard glas breekt in kleine stompe stukjes (veilig bij kinderen). Gelaagd glas bestaat uit twee glasplaten met een folie ertussen en blijft bij breuk hangen — ideaal voor inbraakwerendheid." },
      { q: "Vergoedt mijn verzekering glasvervanging?", a: "Bij inbraak, stormschade of vandalisme wordt glasvervanging meestal vergoed door de opstal- of inboedelverzekering. Na een inbraak maken wij een schadedossier met foto's en factuur voor uw verzekering." },
    ],
  },
  links: {
    h2: "Meer diensten",
    cards: [
      { title: "Kozijnreparatie", desc: "Wilt u meer weten over kozijnreparatie?", href: "/kozijn-reparatie/" },
      { title: "Velux en dakraam", desc: "Wilt u meer weten over Velux en dakraam reparatie?", href: "/velux-reparatie/" },
      { title: "Inbraakschade", desc: "Wilt u meer weten over inbraakschade reparatie?", href: "/inbraakschade-reparatie/" },
    ],
  },
  ctaBanner: {
    h2: "Glas kapot of HR++ upgrade?",
    cta: "📞 Bel 040 798 7470",
  },
  offerte: {
    h2: "Gratis offerte aanvragen",
    intro: "Vertel ons wat u nodig heeft en wij nemen contact op.",
    steps: ["Glastype", "Aantal ramen", "Contact"],
    step1: {
      label: "Welk type glas wilt u laten vervangen?",
      options: [
        "Enkel glas",
        "Dubbel glas HR / HR+",
        "HR++ isolatieglas",
        "HR+++ triple glas",
        "Veiligheidsglas",
        "Anders / ik weet het niet",
      ],
    },
    step2: {
      label: "Hoeveel ramen wilt u laten vervangen?",
      options: [
        "1 raam",
        "2-4 ramen",
        "5-8 ramen",
        "9+ ramen",
        "Complete woning",
      ],
    },
    step3: {
      firstName: "Voornaam",
      lastName: "Achternaam",
      phone: "Telefoon",
      email: "E-mail",
      address: "Adres",
      message: "Bericht",
      back: "Terug",
      next: "Volgende",
      submit: "Verstuur aanvraag",
    },
  },
};

export default translations;